module.exports = __webpack_public_path__ + "img/menu-close-white.321e6a14.svg";